<template>
  <div class="docs">
    <div class="container">
      <div class="docs__wrapper">
        <div class="docs__top">
          <h1 class="docs__title">{{ t('docs.aboutUs.title') }}</h1>
        </div>
        <div class="docs__main" v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {onMounted, ref, watch} from "vue";
import {Docs} from "@/core/api/docs.js";

const {t, locale} = useI18n();

const content = ref(null)

const isLoading = ref(false)

const getDocs = async () => {
  isLoading.value = true

  const res = await Docs.getDocs("about-us")

  if (res.data.posts.edges.length) {
    content.value = res.data.posts.edges[0].node.content
  }

  isLoading.value = false
}

watch(locale, async () => {
  await getDocs()
})

onMounted( async () => {
  await getDocs()
})
</script>

<style lang="scss" scoped>
.docs {
  padding-top: 150px;
  color: #222;

  &__top {
    border-bottom: 1px solid #EDEDED;

    & h1 {
      width: fit-content;
      padding-bottom: 10px;
      border-bottom: 3px solid #008ECC;
      color: #008ECC;
      font-size: 24px;
      font-weight: 700;
      line-height: 30px;
    }
  }

  &__main {
    margin-top: 50px;
  }
}

:deep(ul) {
  padding-left: 20px;
}
:deep(p) {
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
}
:deep(li) {
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
}
:deep(a) {
  color: #ff0000;
  font-weight: 500;

  @include hover {
    color: #af0000;
  }
}

@media (max-width: 750px) {
  .docs {
    &__top {
      padding-block: 40px;
    }

    &__title {
      font-size: 42px;
    }
  }

  :deep(p) {
    font-size: 16px;
  }
  :deep(li) {
    font-size: 16px;
  }
}
</style>